
import { defineComponent, ref, reactive } from 'vue'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])
import { RecommendService } from '@/api/recommand'
import { MemberService } from '@/api/member'
import { message } from 'ant-design-vue'

export default defineComponent({
  name: 'DesignScene',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const recommendList = ref([])
    const isChecked = ref(true)
    const getRecommend = async () => {
      const params = {
      }
      const res = await RecommendService.getSubjectCategory(params)
      res.data.data.forEach((d: any, i: any) => {
        d.checkedList = d.subjectList[0]
        d.checkedId = d.subjectList[0] && d.subjectList[0].id ? d.subjectList[0].id : ''
        if (d.checkedList && d.checkedList.pptTemplateList) {
          d.checkedList.pptTemplateList.forEach(() => {
            const swiper_options = reactive({
              autoplay:false,
              navigation: {
                nextEl: '.scene-slider-list-icon.next' + i,
                prevEl: '.scene-slider-list-icon.prev' + i,
              },
              slidesPerView:8,
              spaceBetween: 20,
              slidesPerGroup:8,
              loop:false,
              speed:500,
              
            })
            d.option = swiper_options
          })
        }
      })
      recommendList.value = res.data.data
    }
    getRecommend()

    const onCollect = async (id: any) => {
      const params = {
        contentId:id
      }
      const res = await MemberService.addCollect(params)
      if (res.data.state === 2) {
        message.success('收藏成功')
      }
      else {
        message.error(res.data.msg)
      }
      
    }
    const onTabs = (d: any,t:any) => {
      d.checkedId = t.id
      d.checkedList = t
      isChecked.value = false
      
    }
    return {
      recommendList,
      onCollect,
      onTabs,
      isChecked
    }
  }
})
